import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  viewChild,
} from '@angular/core'
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms'
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field'
import { MatIcon } from '@angular/material/icon'
import { MatInput } from '@angular/material/input'
import { MatTooltip } from '@angular/material/tooltip'
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerToggle,
} from '@angular/material/datepicker'
import moment from 'moment'
import { SearchReservaTgModel } from '../../../core/models/reserva-compras.model'

@Component({
  selector: 'form-search-reserva-tg',
  imports: [
    MatFormField,
    MatIcon,
    MatInput,
    MatLabel,
    ReactiveFormsModule,
    MatTooltip,
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatSuffix,
  ],
  templateUrl: './form-search-reserva-tg.component.html',
  styleUrl: './form-search-reserva-tg.component.scss',
})
export class FormSearchReservaTgComponent implements OnInit, OnChanges {
  constructor(private formBuilder: FormBuilder) {}

  datepickerStart = viewChild<MatDatepicker<any>>('dateStart')
  datepickerEnd = viewChild<MatDatepicker<any>>('dateEnd')

  formSearch: FormGroup = new FormGroup({})
  @Output() responseSearch = new EventEmitter()
  @Input() search = ''

  ngOnInit() {
    this.createForm()
  }

  ngOnChanges() {}

  createForm(): void {
    this.formSearch = this.formBuilder.group({
      tgCode: [''],
      client: [''],
      dateStart: [''],
      dateEnd: [''],
    })
  }

  sendSearch(search = true) {
    if (search && this.checkSearch()) {
      const searchModel = new SearchReservaTgModel()
      searchModel.codigoTg = this.toNullable(this.formSearch.get('tgCode')!.value)
      searchModel.nomeCliente = this.toNullable(
        this.formSearch.get('client')!.value,
      )
      searchModel.dataInicio = this.formSearch.get('dateStart')!.value
        ? moment(this.formSearch.get('dateStart')!.value).format('YYYY-MM-DD')
        : null
      searchModel.dataFinal = this.formSearch.get('dateEnd')!.value
        ? moment(this.formSearch.get('dateEnd')!.value).format('YYYY-MM-DD')
        : null
      this.responseSearch.emit({ search: search, model: searchModel })
    } else if (!search) {
      this.formSearch.get('tgCode')!.setValue('')
      this.formSearch.get('client')!.setValue('')
      this.formSearch.get('dateStart')!.setValue('')
      this.formSearch.get('dateEnd')!.setValue('')

      this.responseSearch.emit({ search: search, model: {} })
    }
  }

  private toNullable(value: string): string | null {
    return value && value.trim().length > 0 ? value : null
  }

  checkSearch() {
    if (
      this.formSearch.get('tgCode')!.value.trim().length > 0 ||
      this.formSearch.get('client')!.value.trim().length > 0 ||
      this.formSearch.get('dateStart')!.value ||
      this.formSearch.get('dateEnd')!.value
    ) {
      return true
    } else {
      return false
    }
  }

  openDatepicker(type: 'dateStart' | 'dateEnd') {
    if (type == 'dateStart') {
      this.datepickerStart()?.open()
    } else if (type == 'dateEnd') {
      this.datepickerEnd()?.open()
    }
  }
}
